module.exports = __webpack_public_path__ + "img/download_r2.adc03787.jpg";